"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderItem = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const trade_1 = require("@tencent/tccp-frontend-contract/trade");
const order_1 = require("../modules/order");
const useInject_1 = require("./useInject");
// 1秒之内算不出来orderItem算失败
const ORDER_ITEM_OUTPUT_TIMEOUT = 1000;
function useOrderItem(spuCode, { paramList_, values_, validator_ }, injectModule) {
    // 创建订阅关系
    const orderItem_ = (0, react_1.useMemo)(() => (0, rxjs_1.combineLatest)([
        (0, rxjs_1.of)(spuCode).pipe((0, rxjs_1.filter)(spuCode => !!spuCode), (0, rxjs_1.map)(order_1.orderItemBuilderFactory)),
        paramList_.pipe((0, rxjs_1.filter)(paramList => paramList.length > 0)),
        values_.pipe((0, rxjs_1.map)(values => values)),
        validator_,
    ]).pipe((0, rxjs_1.filter)(([, , values, validator]) => {
        const result = validator.validate(values);
        // 排除掉额外的拓展规格校验
        const hasError = !!Object.values(result).filter(r => (r === null || r === void 0 ? void 0 : r.entity.paramKey) && !isExternalParameterParamKey(r.entity.paramKey)).length;
        return !hasError;
    }), (0, rxjs_1.map)(([orderItemBuilder, paramList, values]) => (0, useInject_1.injectRunner)(orderItemBuilder, [paramList, values], injectModule))), [spuCode, paramList_, values_, validator_, injectModule]);
    const orderItemWithTimeout_ = (0, react_1.useMemo)(() => orderItem_.pipe((0, rxjs_1.raceWith)((0, rxjs_1.interval)(ORDER_ITEM_OUTPUT_TIMEOUT).pipe((0, rxjs_1.switchMap)(() => (0, rxjs_1.throwError)(() => new Error('Get OrderItem Timeout')))))), [orderItem_]);
    return { orderItem_, orderItemWithTimeout_ };
}
exports.useOrderItem = useOrderItem;
function isExternalParameterParamKey(paramKey) {
    return paramKey.startsWith(`${trade_1.ParamTypeEnum.ExternalParameter}://`);
}
